module.exports = __webpack_public_path__ + "static/media/btn-cancel.0e90c190.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/btn-cancel.svg
// module id = 386
// module chunks = 0